module.exports = __webpack_public_path__ + "static/media/ghost.86dde6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/ghost.png
// module id = 524
// module chunks = 0